import styled from "styled-components";

export const Box = styled.div`
  .formaSpeedChecker {
    display: flex;
    justify-content: center;
    gap: 10px;
  }
  .inputStyleSpeed {
    maxwidth: 400px;
  }
  .speedCardBox {
    padding: 30px;
  }
  .buttonSpeed {
  }
  @media (max-width: 600px) {
    .speedCardBox {
      padding: 15px;
    }
    .formaSpeedChecker {
      display: block;
    }
    .inputStyleSpeed {
      maxwidth: 100%;
    }
    .buttonSpeed {
      margin-top: 1rem;
      width: 100%;
    }
  }
`;
